<script>
import EventHeaderDropdown from './EventHeaderDropdown.vue';
import RelativeTime from '../RelativeTime/RelativeTime.vue';
import EventHeaderTabs from './EventHeaderTabs.vue';

export default {
  name: 'FormGuideEventHeaderDesktop',
  components: {
    EventHeaderDropdown,
    RelativeTime,
    EventHeaderTabs,
  },
  props: {
    startTime: {
      type: String,
      required: true,
    },
    eventName: {
      type: String,
      required: true,
    },
    localStart: {
      type: String,
      required: true,
    },
    isResulted: {
      type: Boolean,
      required: true,
    },
    isImminent: {
      type: Boolean,
      required: true,
    },
    isEnded: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<template>
  <div class="form-guide-event-header-desktop">
    <div class="form-guide-event-header-desktop__container">
      <div class="form-guide-event-header-desktop__left">
        <div class="form-guide-event-header-desktop__time">
          <RelativeTime
            v-if="isImminent || isEnded"
            :brand="`punters`"
            :target-time="startTime"
            :is-resulted="isResulted"
          />
          <div
            v-if="startTime"
            class="form-guide-event-header-desktop__start-time"
          >{{ startTime | sportsCalendarPunters }} {{ localStart | puntersDisplayTime }}</div>
        </div>
        <div class="form-guide-event-header-desktop__name">{{ eventName }}</div>
      </div>
      <div class="form-guide-event-header-desktop__right">
        <div class="form-guide-event-header-desktop__dropdowns">
          <EventHeaderDropdown :dropdown-type="`eventCondition`" />
          <EventHeaderDropdown :dropdown-type="`prizeMoney`" />
          <EventHeaderDropdown :dropdown-type="`trackDistance`" />
          <EventHeaderDropdown :dropdown-type="`trackCondition`" />
        </div>
      </div>
    </div>
    <EventHeaderTabs />
  </div>
</template>
